module.exports = __webpack_public_path__ + "img/bc4_home.ff272b43.png";